import { Functie } from "@/entities/contactpersoon";
import { Badge } from "@/shared/components";

type FunctieAvatarProps = {
    functies: Functie[];
};

export function FunctieAvatar({ functies }: FunctieAvatarProps) {
    if (functies.length === 1) {
        return (
            <div className="relative flex h-[50px] w-[51px] shrink-0 overflow-hidden">
                <div className="bg-brand-primary flex size-10 items-center justify-center rounded-full">
                    <span className="text-content-emphasis text-s leading-m flex font-bold">{functies[0]}</span>
                </div>
            </div>
        );
    }

    return (
        <div className="relative flex h-[50px] w-[51px] shrink-0 overflow-hidden">
            <span className="bg-brand-primary text-content-emphasis text-s leading-m flex size-10 items-center justify-center rounded-full font-bold">
                {functies[0]}
            </span>
            <Badge className="bg-accent text-content-on-accent-subtle absolute right-0 bottom-0" variant="gray-subtle">
                +{functies.length - 1}
            </Badge>
        </div>
    );
}
